import { TrendingUp, TrendingDown } from 'lucide-react';

const colorStyles = {
  cyan: 'from-cyan-500 to-blue-500',
  purple: 'from-purple-500 to-pink-500',
  green: 'from-green-500 to-emerald-500',
  orange: 'from-orange-500 to-amber-500',
  red: 'from-red-500 to-rose-500'
};

export function StatCard({
  title,
  value,
  icon: Icon,
  trend,
  max,
  color = 'cyan'
}) {
  const gradientClass = colorStyles[color];

  return (
    <div className="bg-slate-900/80 border border-slate-700/50 rounded-xl p-6 backdrop-blur-sm hover:border-cyan-500/30 transition-all">
      <div className="flex items-start justify-between">
        <div>
          <p className="text-gray-400 text-sm mb-1">{title}</p>
          <div className="flex items-baseline gap-2">
            <p className="text-2xl font-bold text-white">{value}</p>
            {max && (
              <span className="text-sm text-gray-500">/ {max}</span>
            )}
          </div>
          {trend !== undefined && (
            <div className={`flex items-center gap-1 mt-2 text-sm ${
              trend >= 0 ? 'text-green-400' : 'text-red-400'
            }`}>
              {trend >= 0 ? (
                <TrendingUp className="w-4 h-4" />
              ) : (
                <TrendingDown className="w-4 h-4" />
              )}
              <span>{trend >= 0 ? '+' : ''}{trend}%</span>
            </div>
          )}
        </div>
        <div className={`p-3 rounded-lg bg-gradient-to-br ${gradientClass}`}>
          <Icon className="w-6 h-6 text-white" />
        </div>
      </div>
    </div>
  );
}
